import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { Modal } from 'react-bootstrap';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Icon3 from '../../assest/images/Icon3.png';
import Icon5 from '../../assest/images/Icon5.png';
import Icon4 from '../../assest/images/Icon4.png';
import accept from '../../assest/images/accept.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomDropdown from '../common/CustomDropdown';
import StatusCustomDropdown from '../common/StatusCustomDropdown';
import SCPConfigDropdown from '../common/SCPConfigDropdown';

import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import { set } from 'date-fns';

const SCPConfigEdit = () => {
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [company, setCompany] = useState('');
  const [selectedSCPIndex, setSelectedSCPIndex] = useState(null);
  const [scpTable, setScpTable] = useState([]);
  const [initialScpTable, setInitialScpTable] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const { cgmId, cgmCompanyName } = useParams();
  const [scpName, setScpName] = useState('');
  const [originalScpNames, setOriginalScpNames] = useState({});
  const [attemptedAddEmpty, setAttemptedAddEmpty] = useState(false);
  const [errors, setErrors] = useState({});
  const [initialData, setInitialData] = useState({ success: true, data: [] });
  const [suspendConfirmationModal, setSuspendConfirmationModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showEditWarningIndex, setShowEditWarningIndex] = useState(null);
  

  const navigate = useNavigate();

  const caretRef = useRef(0);
  
  
    useEffect(() => {
      const input = document.activeElement;
      if (input && input.tagName === 'INPUT') {
        const pos = caretRef.current;
        input.setSelectionRange(pos, pos);
      }
    }, [scpTable]);
  

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);
  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

  const handleInputChange = (e) => {
    let inputValue = e.target.value;

    // ✅ Only enforce max length (50)
    if (inputValue.length > 50) {
      inputValue = inputValue.slice(0, 50);
    }

    // ✅ Set value as-is (no sanitization)
    setScpName(inputValue);

    // ✅ Validation ONLY
    const errorMessage = validateScpName(inputValue);
    setErrorMessage(errorMessage);
  };


  useEffect(() => {
    fetchSavedData();
  }, [cgmId]);

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "SCP-Configuration", action, userCode: UM_UserCode, isError }),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const logAudit = async (module, message, oldValue = "", newValue = "", transactionDetails = []) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 14,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0,
      transactionDetails
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const validateScpName = (value) => {
    if (!value || value.trim() === '') return '';

    if (value.length > 45) {
      return 'Maximum 45 characters allowed';
    }

    // Only allowed special characters
    if (!/^[A-Za-z0-9\-_ ]+$/.test(value)) {
      return 'Please use only special characters like -, _ and space';
    }

    // ✅ First and last must be alphanumeric
    // Ignore single-character case
    if (
      value.length > 1 &&
      (!/^[A-Za-z0-9]/.test(value) || !/[A-Za-z0-9]$/.test(value))
    ) {
      return 'The first and last characters must be alphanumeric';
    }

    // No consecutive special characters (including mixed)
    if (/[\-_. ]{2,}/.test(value)) {
      return 'No consecutive special characters allowed';
    }

    return '';
  };

  const handleScpNameChange = (e, index) => {
    logAction('handleScpNameChange():started');

    let inputValue = e.target.value;

    // ✅ Only enforce max length
    if (inputValue.length > 50) {
      inputValue = inputValue.slice(0, 50);
    }

    // Update table value as-is
    const updatedTable = [...scpTable];
    updatedTable[index].SCP_LevelName = inputValue;
    setScpTable(updatedTable);

    // ✅ Validate ONLY
    const errorMessage = validateScpName(inputValue);
    setErrors((prev) => ({
      ...prev,
      [`SCPName${index}`]: errorMessage,
    }));

    logAction('handleScpNameChange():ended');
  };

  const fetchSavedData = async () => {
    logAction('fetchSavedData():started');
    try {
      const response = await fetch(`${config.API_URL}/api/scpconfiguration/${cgmId}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      console.log('Fetched data:', data);
      setInitialData(data);
      if (data.success && data.data) {
        logAction(`configuration for company group name ${cgmId} fetched successfully in the edit page`);
        setCompany(data.data[0].SCP_CompanyGrpID);
        const adjustedData = data.data.map(row => ({
          ...row,
          SCP_AllowMutliplePartyOutward: row.SCP_AllowMutliplePartyOutward === 0 ? 'No' : 'Yes',
          SCP_AllowMutliplePartySameLevelOutward: row.SCP_AllowMutliplePartySameLevelOutward === 0 ? 'No' : 'Yes',
        }));
        setScpTable(adjustedData);
        setInitialScpTable(JSON.parse(JSON.stringify(adjustedData))); // Deep copy
        setDataLoaded(true);
        const originalNames = {};
        adjustedData.forEach((row, index) => {
          originalNames[index] = row.SCP_LevelName;
        });
        setOriginalScpNames(originalNames);
      } else {
        logAction(`Error occurred showing configuration for company group name ${cgmId}`, true);
        throw new Error(data.message || 'Failed to fetch saved data');
      }
    } catch (error) {
      logAction(`Error occurred showing configuration for company group name ${cgmId}`, true);
      console.error('Error fetching saved data:', error);
    }
    logAction('fetchSavedData():ended');
  };

  const handleEditRow = (index) => {
    logAction('handleEditRow():started');
    const updatedTable = [...scpTable];
    updatedTable[index].isEditing = true;
    updatedTable[index].originalSCP_LevelName = updatedTable[index].SCP_LevelName;
    setScpTable(updatedTable);
    caretRef.current = updatedTable[index].SCP_LevelName.length;
    logAction('handleEditRow():ended');
  };

  const handleSaveEdit = (index) => {
    logAction('handleSaveEdit():started');
    const updatedTable = [...scpTable];
    const editedName = updatedTable[index].SCP_LevelName.trim();

    let newErrors = {};
    let isValid = true;

    if (!/^[A-Za-z0-9]+(?:[-_ ]?[A-Za-z0-9]+)*$/.test(editedName)) {
      logAction(`handleSaveEdit():Invalid SCP name ${editedName}`, true);
      newErrors = {
        ...newErrors,
        [`SCPName${index}`]: 'Invalid SCP Name',
      };
      isValid = false;
    }

    if (updatedTable.some((row, i) => row.SCP_LevelName.trim() === editedName && i !== index)) {
      logAction(`handleSaveEdit():SCP Name ${editedName} already exists in the table`, true);
      newErrors = {
        ...newErrors,
        [`SCPName${index}`]: 'SCP Name already exists in the table',
      };
      isValid = false;
    }

    if (!isValid) {
      logAction('handleSaveEdit():Invalid SCP name', true);
      setErrors(newErrors);
      return;
    }

    updatedTable[index].SCP_LevelName = editedName;
    updatedTable[index].isEditing = false;
    setScpTable(updatedTable);
    setShowEditWarningIndex(null);
    setErrors({});
    logAction('handleSaveEdit():ended');
  };

  const handleCancelEdit = (index) => {
    logAction('handleCancelEdit():started');
    const updatedTable = [...scpTable];
    updatedTable[index].isEditing = false;
    updatedTable[index].SCP_LevelName = updatedTable[index].originalSCP_LevelName;
    setScpTable(updatedTable);
    setErrors({});
    logAction('handleCancelEdit():ended');
  };

  const handleRemoveRow = (index) => {
    setSelectedSCPIndex(index);
    setSuspendConfirmationModal(true);
  };

  const handleAddRow = () => {
    setLoading(true);
    logAction('handleAddRow():started');
    const editedName = scpName.trim();

    if (!editedName) {
      setAttemptedAddEmpty(true);
      logAction('handleAddRow():Attempted to add empty SCP name', true);
      setLoading(false);
      return;
    }

    if (validateScpName(scpName)) {
      logAction('handleAddRow():Invalid SCP name', true);
      setLoading(false);
      return;
    }

    const isSCPNameExists = scpTable.some(row => row.SCP_LevelName.trim().toLowerCase() === editedName.trim().toLowerCase());


    if (!isSCPNameExists) {
      const newRow = {
        SCP_LevelNo: scpTable.length + 1,
        SCP_LevelName: editedName,
        SCP_AllowMutliplePartyOutward: 'No',
        SCP_AllowMutliplePartySameLevelOutward: 'No',
      };
      setScpTable([...scpTable, newRow]);
      setScpName('');
      setAttemptedAddEmpty(false);
      setLoading(false);
    } else {
      toast.error(`SCP Level Name : ${scpName} already exists.`,{ onClose: () => { setLoading(false); } });
    }
    logAction('handleAddRow():ended');
  };

  const handleReset = () => {
    logAction('handleReset():started');
    setCompany('');
    setScpName('');
    setErrorMessage('');
    setScpTable([]);
    setAttemptedAddEmpty(false);
    logAction('handleReset():ended');
  };

  const handleSubmit = async (e) => {
    logAction('handleSubmit():started');
    e.preventDefault();

    if (isAnyRowEditing) {
      const editingIndex = scpTable.findIndex(r => r.isEditing);
      setShowEditWarningIndex(editingIndex);
      return;
    }

    if (scpTable.length === 0) {
      setAttemptedAddEmpty(true);
      logAction('handleSubmit():Attempted to submit with empty table', true);
      return;
    }

    if (scpTable.some(row => row.isEditing)) {
      toast.error(`Please save or cancel the SCP Name Edit before submitting.`);
      logAction('handleSubmit():Attempted to submit with row in edit mode', true);
      return;
    }

    // Validate hierarchy
    try {
      setLoading(true);
      const hierarchyResponse = await fetch(`${config.API_URL}/validatehierarchy/${cgmId}`, {
        method: 'GET',
      });

      if (!hierarchyResponse.ok) {
        throw new Error('Network response was not ok');
      }

      const hierarchyData = await hierarchyResponse.json();
      if (hierarchyData.success) {
        const hierarchy = hierarchyData.data;
        // Create a map of SCP_ID to its index in the hierarchy for quick lookup
        const hierarchyOrder = {};
        hierarchy.forEach((item, index) => {
          hierarchyOrder[item.SCP_ID] = index;
        });

        // Check if the SCP_IDs in scpTable maintain the relative order from hierarchy
        for (let i = 1; i < scpTable.length; i++) {
          const currentRow = scpTable[i];
          const prevRow = scpTable[i - 1];

          // Only check if both SCP_IDs are in the hierarchy
          if (hierarchyOrder[currentRow.SCP_ID] !== undefined && hierarchyOrder[prevRow.SCP_ID] !== undefined) {
            if (hierarchyOrder[prevRow.SCP_ID] > hierarchyOrder[currentRow.SCP_ID]) {
              toast.error(`SCP Level : ${currentRow.SCP_LevelName} must come above SCP Level : ${prevRow.SCP_LevelName} because reference exists in SCP Master.`, { onClose: () => { setLoading(false); } });
              logAction(`handleSubmit(): Hierarchy violation - ${currentRow.SCP_LevelName} (SCP_ID: ${currentRow.SCP_ID}) should follow ${prevRow.SCP_LevelName} (SCP_ID: ${prevRow.SCP_ID})`);
              return;
            }
          }
        }
      } else {
        throw new Error(hierarchyData.message || 'Failed to validate hierarchy');
      }
    } catch (error) {
      console.error('Error validating hierarchy:', error.message);
      //toast.error("Some problem occurred during hierarchy validation");
      logAction('handleSubmit(): Hierarchy validation failed');
      return;
    }
    finally { setLoading(false); }

    const dataToSend = scpTable.map(row => ({
      SCP_CompanyGrpID: cgmId,
      SCP_ID: row.SCP_ID,
      SCP_LevelNo: row.SCP_LevelNo,
      SCP_LevelName: row.SCP_LevelName,
      SCP_AllowMutliplePartySameLevelOutward: row.SCP_AllowMutliplePartySameLevelOutward === 'Yes' ? 1 : 0,
      SCP_AllowMutliplePartyOutward: row.SCP_AllowMutliplePartyOutward === 'Yes' ? 1 : 0,
      SCP_Createdby: UM_UserId,
      SCP_ModifiedBy: UM_UserId,
    }));

    const initialDataArray = initialData.data;

    const transactionDetails = [
      {
        AUTRN_ParamererName: "SCP Configuration Details",
        AUTRN_OldValue: JSON.stringify(initialScpTable.map(row => ({
          "SCP Level No.": row.SCP_LevelNo,
          "SCP Level Name": row.SCP_LevelName,
          "SCP Allow Mutliple Party Outward": row.SCP_AllowMutliplePartyOutward,
          "SCP Allow Same Level Mutliple Party Outward": row.SCP_AllowMutliplePartySameLevelOutward,
        }))),
        AUTRN_NewValue: JSON.stringify(scpTable.map(row => ({
          "SCP Level No.": row.SCP_LevelNo,
          "SCP Level Name": row.SCP_LevelName,
          "SCP Allow Mutliple Party Outward": row.SCP_AllowMutliplePartyOutward,
          "SCP Allow Same Level Mutliple Party Outward": row.SCP_AllowMutliplePartySameLevelOutward,
        })))
      }
    ];

    for (let currentRow of scpTable) {
      const initialRow = initialDataArray.find(row => row.SCP_LevelNo === currentRow.SCP_LevelNo);
      if (initialRow) {
        const initialAllowMultiple = initialRow.SCP_AllowMutliplePartyOutward === 1 ? 'Yes' : 'No';
        const currentAllowMultiple = currentRow.SCP_AllowMutliplePartyOutward;

        if (initialAllowMultiple === 'Yes' && currentAllowMultiple === 'No') {
          try {
            setLoading(true);
            const response = await fetch(`${config.API_URL}/scpmaster/totalcount/${currentRow.SCP_LevelNo}/${cgmId}`, {
              method: 'GET',
            });

            if (!response.ok) {
              throw new Error('Network response was not ok');
            }

            const { totalCount } = await response.json();
            if (totalCount > 0) {
              toast.error(`Cannot change SCP AllowMultiplePartyOutward from Yes to No because reference exists in the SCP Master for SCP Level: ${currentRow.SCP_LevelName}.`);
              logAction('handleSubmit(): Aborting save due to totalCount check');
              return;
            }
          } catch (error) {
            console.error('Error checking total count:', error.message);
            //toast.error("Some problem occurred during checking the total count");
            return;
          }
          finally { setLoading(false); }
        }
      }
    }

    for (let currentRow of scpTable) {
      const initialRow = initialDataArray.find(row => row.SCP_LevelNo === currentRow.SCP_LevelNo);
      if (initialRow) {
        const initialAllowMultiple = initialRow.SCP_AllowMutliplePartySameLevelOutward === 1 ? 'Yes' : 'No';
        const currentAllowMultiple = currentRow.SCP_AllowMutliplePartySameLevelOutward;

        if (initialAllowMultiple === 'Yes' && currentAllowMultiple === 'No') {
          try {
            setLoading(true);
            const response = await fetch(`${config.API_URL}/scpmaster/totalcount/${currentRow.SCP_LevelNo}/${cgmId}`, {
              method: 'GET',
            });

            if (!response.ok) {
              throw new Error('Network response was not ok');
            }

            const { totalCount } = await response.json();
            if (totalCount > 0) {
              toast.error(`Cannot change SCP_AllowMutliplePartySameLevelOutward from Yes to No because reference exists in the scpmaster for SCP Level Name ${currentRow.SCP_LevelName}.`);
              logAction('handleSubmit(): Aborting save due to totalCount check');
              return;
            }
          } catch (error) {
            console.error('Error checking total count:', error.message);
            //toast.error("Some problem occurred during checking the total count");
            return;
          }
          finally { setLoading(false); }
        }
      }
    }

    for (let initialRow of initialDataArray) {
      const currentRow = scpTable.find(row => row.SCP_LevelNo === initialRow.SCP_LevelNo);
      if (!currentRow) {
        try {
          setLoading(true);
          const response = await fetch(`${config.API_URL}/scpmaster/totalcount/${initialRow.SCP_LevelNo}/${cgmId}`, {
            method: 'GET',
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const { totalCount } = await response.json();
          if (totalCount > 0) {
            toast.error(`Cannot remove SCP Level No ${initialRow.SCP_LevelNo} because reference exists in the scpmaster.`);
            logAction('handleSubmit(): Aborting save due to totalCount check');
            return;
          }
        } catch (error) {
          console.error('Error checking total count:', error.message);
          //toast.error("Some problem occurred during checking the total count");
          return;
        }
        finally { setLoading(false); }
      }
    }

    try {
      setLoading(true);
      const response = await fetch(`${config.API_URL}/api/scpconfiguration/${cgmId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const responseData = await response.json();
      if (responseData.success) {
        toast.success(`Configuration for Company Group Name : ${cgmCompanyName} updated successfully.`, {
          onClose: () => {
           
            handleReset();
            setLoading(false);
            navigate(`/dashboard/scpconfig`);
          }
        });

        logAudit('SCP Configuration', `Configuration for ${cgmCompanyName} is updated successfully in the database`, '-', '-', transactionDetails);

        // setScpTable([]);
        // handleReset();
      } else {
        setLoading(false);
        throw new Error(responseData.message || 'Failed to update data');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error updating data:', error.message);
      //toast.error("Some problem occurred during saving the configuration");
    }

    logAction('handleSubmit():ended');
  };

  const isAnyRowEditing = scpTable.some(row => row.isEditing);

  const moveRow = (dragIndex, hoverIndex) => {
    if (isAnyRowEditing) return; // Block drag & drop when editing

    const draggedRow = scpTable[dragIndex];
    const updatedTable = [...scpTable];
    updatedTable.splice(dragIndex, 1);
    updatedTable.splice(hoverIndex, 0, draggedRow);

    updatedTable.forEach((row, index) => {
      row.SCP_LevelNo = index + 1;
    });

    setScpTable(updatedTable);
  };

  const TableRow = ({ row, index }) => {
    console.log("row in TableRow:", row);
    const [{ isDragging }, drag] = useDrag({
      type: 'ROW',
      item: { index },
      canDrag: () => !isAnyRowEditing,  // Disable drag completely during edit
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });

    const [, drop] = useDrop({
      accept: 'ROW',
      hover: (item) => {
        if (isAnyRowEditing || !item) return;
        const dragIndex = item.index;
        const hoverIndex = index;
        if (dragIndex === hoverIndex) return;
        moveRow(dragIndex, hoverIndex);
        item.index = hoverIndex;
      },
    });

    const opacity = isDragging ? 0.5 : 1;

    // Only attach drag/drop when no row is editing
    const rowRef = isAnyRowEditing ? null : (node) => drag(drop(node));

    return (
      <tr
        ref={rowRef}
        style={{
          opacity,
          cursor: isAnyRowEditing ? 'default' : 'move',
        }}
      >
        <td>{row.SCP_LevelNo}</td>
        <td>
          {row.isEditing ? (
            <input
              type="text"
              value={row.SCP_LevelName}
              //onChange={(e) => handleScpNameChange(e, index)}
              onChange={(e) => {
                const input = e.target;
            
                // 🔥 store caret position
                caretRef.current = input.selectionStart;
            
                let inputValue = input.value;
            
                // max length enforcement
                if (inputValue.length > 50) {
                  inputValue = inputValue.slice(0, 50);
                }
            
                // ✅ update SAME field used in value
                setScpTable(prev => {
                  const updated = [...prev];
                  updated[index] = {
                    ...updated[index],
                    SCP_LevelName: inputValue
                  };
                  return updated;
                });
            
                // validation
                const errorMessage = validateScpName(inputValue);
                setErrors(prev => ({
                  ...prev,
                  [`SCPName${index}`]: errorMessage,
                }));
              }}
              autoFocus
              className="form-input"
              style={{ width: '100%' }}
            />
          ) : (
            <span>{row.SCP_LevelName}</span>
          )}
          {errors[`SCPName${index}`] && (
            <div style={{ color: 'red', fontWeight: '400' }}>{errors[`SCPName${index}`]}</div>
          )}
        </td>

        {/* DROPDOWN 1 - Locked during edit */}
        <td>
          <div>
            <div className='select-container_list'>
              <SCPConfigDropdown
                name={`SCP_AllowMutliplePartyOutward_${index}`}
                options={[
                  { value: 'Yes', label: 'Yes' },
                  { value: 'No', label: 'No' }
                ]}
                value={row.SCP_AllowMutliplePartyOutward || 'No'}
                onChange={(e) => {
                  const updatedTable = [...scpTable];
                  updatedTable[index].SCP_AllowMutliplePartyOutward = e.target.value;
                  setScpTable(updatedTable);
                }}
                idKey='value'
                displayKey='label'
                disabled={isAnyRowEditing}
                enableScrollEffect={index === scpTable.length - 1 && index > 1}
              />
            </div>
          </div>
        </td>

        {/* DROPDOWN 2 - Locked during edit */}
        <td>
          <div style={{
            pointerEvents: isAnyRowEditing ? 'none' : 'auto',
            opacity: isAnyRowEditing ? 0.6 : 1
          }}>
            <div className='select-container_scpconfig'>
              <SCPConfigDropdown
                name={`SCP_AllowMutliplePartySameLevelOutward_${index}`}
                options={[
                  { value: 'Yes', label: 'Yes' },
                  { value: 'No', label: 'No' }
                ]}
                value={row.SCP_AllowMutliplePartySameLevelOutward || 'No'}
                onChange={(e) => {
                  const updatedTable = [...scpTable];
                  updatedTable[index].SCP_AllowMutliplePartySameLevelOutward = e.target.value;
                  setScpTable(updatedTable);
                }}
                idKey='value'
                displayKey='label'
                disabled={isAnyRowEditing}
                enableScrollEffect={index === scpTable.length - 1 && index > 1}
              />
            </div>
          </div>
        </td>

        <td style={{ paddingLeft: '18px', width: '90px' }}>
          {row.isEditing ? (
            <>
              <img
                src={accept}
                alt="save"
                title='Save'
                className="suspendicon"
                style={{ cursor: 'pointer', marginRight: '10px' }}
                onClick={() => handleSaveEdit(index)}
              />
              {showEditWarningIndex === index && (
                <span
                  style={{
                    color: 'red',
                    fontWeight: 'bold',
                    marginRight: '10px'
                  }}
                >
                  *
                </span>
              )}
              <img
                src={Icon5}
                alt="cancel"
                title='Cancel'
                className="suspendicon"
                style={{ cursor: 'pointer' }}
                onClick={() => handleCancelEdit(index)}
              />
            </>
          ) : (
            <>
              <img
                src={Icon3}
                alt="Edit"
                title='Edit'
                className="editicon"
                style={{
                  cursor: isAnyRowEditing ? 'not-allowed' : 'pointer',
                  opacity: isAnyRowEditing ? 0.5 : 1
                }}
                onClick={() => !isAnyRowEditing && handleEditRow(index)}
              />
              <img
                src={Icon5}
                alt="Remove"
                title='Remove'
                //className="suspendicon"
                style={{
                  cursor: isAnyRowEditing ? 'not-allowed' : 'pointer',
                  opacity: isAnyRowEditing ? 0.5 : 1,
                  marginLeft: '10px',
                  paddingRight: '5px'
                }}
                onClick={() => !isAnyRowEditing && handleRemoveRow(index)}
              />
            </>
          )}
        </td>
      </tr>
    );
  };

  const handleCloseModal = () => {
    setSuspendConfirmationModal(false);
    setSelectedSCPIndex(null);
  };

  const handleConfirmSuspend = () => {
    if (selectedSCPIndex !== null) {
      const updatedTable = scpTable
        .filter((_, i) => i !== selectedSCPIndex)
        .map((row, index) => ({
          ...row,
          SCP_LevelNo: index + 1
        }));

      setScpTable(updatedTable);
      setSelectedSCPIndex(null);
    }
    setSuspendConfirmationModal(false);
  };

  return (
    <form onSubmit={handleSubmit} autoComplete="off" onKeyDown={(e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
      }
    }}>

      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
          }}
        />
      )}

      <div className='main_container'>
        <h1 className='formHeading'>SCP Configuration</h1>

        <div className='row'>
          <div className='col-sm-5'>
            <label htmlFor="company">Company Group Name</label>
            <input
              type="text"
              id="company"
              value={cgmCompanyName}
              disabled
              className="form-input"
            />
          </div>
          <div className='col-sm-6'>
            <label htmlFor="scpName">SCP Level Name <span style={{ color: 'red' }}>{attemptedAddEmpty && !scpName && '*'}</span></label>
            <input
              type="text"
              id="scpName"
              value={scpName}
              onChange={handleInputChange}
              placeholder="Enter SCP Level Name"
              className="form-input"
              disabled={isAnyRowEditing}
            />
            {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
          </div>
          <div className='col-sm-1'>
            <button type="button" onClick={handleAddRow} className="scp_add_btn" disabled={isAnyRowEditing}
              style={{
                cursor: isAnyRowEditing ? "default" : "pointer",
                opacity: isAnyRowEditing ? 0.6 : 1
              }}>ADD</button>
          </div>
        </div>

        <div>
          {dataLoaded && scpTable && scpTable.length > 0 && (
            <DndProvider backend={HTML5Backend}>
              <table className="scpconfigtableClass mt-5">
                <thead>
                  <tr>
                    {/* <th>SCP Level ID</th> */}
                    <th>SCP Level No</th>
                    <th>SCP Level Name</th>
                    <th>Allow Multiple Party Outward</th>
                    <th>Allow Same Level Multiple Party Outward</th>
                    <th style={{width: '90px'}}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {scpTable.map((row, index) => (
                    <TableRow key={row.id} row={row} index={index} />
                  ))}
                </tbody>
              </table>
            </DndProvider>
          )}
        </div>
      </div>
      <div className='button-container'>
        <button type="submit" className="save_btn" 
          style={{
            cursor:  "pointer"
          }}>SAVE</button>
        <button type="button" onClick={handleReset} className="reset_btn" disabled={isAnyRowEditing}
          style={{
            cursor: isAnyRowEditing ? "default" : "pointer"
          }}>RESET</button>
        <Link to={`/scpconfiglist`} className={`list_btn ${isAnyRowEditing ? 'disabled' : ''}`}
          onClick={(e) => { if (isAnyRowEditing) e.preventDefault(); }}
          style={{
            cursor: isAnyRowEditing ? "default" : "pointer",
            pointerEvents: isAnyRowEditing ? "none" : "auto",
            opacity: isAnyRowEditing ? 0.6 : 1
          }}>LIST</Link>
      </div>

      {suspendConfirmationModal && (
        <div className="popup_overlay">
          <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>Are you sure you want to remove SCP Configuration : {scpTable[selectedSCPIndex]?.SCP_LevelName} ?</h4>
            <div className="popup_btn_container">
              <button className="yes_btn " onClick={handleConfirmSuspend}>
                YES
              </button>
              <button className="no_btn " onClick={handleCloseModal}>
                NO
              </button>
            </div>
          </div>
        </div>
      )}
    </form>
  );
};

export default SCPConfigEdit;